export const AUTH_TOKEN_LOCAL_STORAGE_KEY = 'token';

export const ROUTES_ACCESSIBLE_WITHOUT_AUTH = [ '/login', '/reset-password', '/forgot-password'];
